import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { Text } from "../styles/Global";

const SkeletonLoader = ({ h1, h2, h3, direction, array, justify, align }) => {
  // console.log("skeletonloader array: ", array);
  // console.log("skeletonloader h1 h2 h3: ", h1, h2, h3);
  return (
    <Stack
      spacing={array ? 0 : 2}
      style={{
        flex: 1,
        marginTop: 10,
        flexDirection: direction ? direction : "column",
        justifyContent: justify ? justify : "flex-start",
        alignItems: align ? align : "flex-start",
        width: "100%",
      }}
    >
      {array ? (
        array.map((item, index) => {
          // console.log("skeleton item: ", item);
          return (
            <Skeleton
              key={index.toString()}
              variant="rectangular"
              height={item.h ? item.h : 50}
              width={item.w && item.w}
              style={item.style ? item.style : { borderRadius: 20 }}
            />
          );
        })
      ) : (
        <>
          <Skeleton
            variant="rectangular"
            height={h1 ? h1 : 50}
            width="100%"
            style={{ borderRadius: 20 }}
          />
          <Skeleton
            variant="rectangular"
            height={h2 ? h2 : 50}
            width="100%"
            style={{ borderRadius: 20 }}
          />
          <Skeleton
            variant="rectangular"
            height={h3 ? h3 : 50}
            width="100%"
            style={{ borderRadius: 20 }}
          />
        </>
      )}
    </Stack>
  );
};

export default SkeletonLoader;
